import $ from 'jquery';

let mobileBreakpoint = 0;

function getHeaderHeight(selector = '.site__header ') {
  const $header = $(selector);
  return $header.height();
}

function isMobile() {
  return window.innerWidth <= mobileBreakpoint;
}

function resizeContent(selector = '.section__content') {
  const $content = $(selector);

  if (isMobile()) {
    $content.css('height', 'auto');
    return;
  }

  $content.css('height', `calc(100vh - ${getHeaderHeight()}px)`);
}

export default function layoutSize(mobileWidth = 670) {
  mobileBreakpoint = mobileWidth;

  document.addEventListener('resize', resizeContent);
  resizeContent();
}


// WEBPACK FOOTER //
// ./scripts/lib/layoutSize.js